import { css } from '@/styled-system/css';

export const widgetStyles = css.raw({ display: 'flex', flexDirection: 'column', gap: 'default' });

export const headerStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'default',
});

export const headingStyles = css.raw({ textStyle: { base: 'body-bold', lg: 'heading-xs' } });

export const tileRowStyles = css.raw({ display: 'flex', gap: 'default' });

export const tileContentStyles = css.raw({ display: 'flex', flexDirection: 'column', alignItems: 'center' });

export const tileLinkStyles = css.raw({ display: 'block', color: 'inherit', textDecoration: 'none' });

export const dayEventListStyles = css.raw({ display: 'flex', flexDirection: 'column', gap: 'default' });

export const dayChipRowStyles = css.raw({ display: 'flex', gap: 'tighter', flexWrap: 'wrap' });

export const eventCardListStyles = css.raw({ display: 'flex', flexDirection: 'column', gap: 'tighter' });

export const eventCardContentStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'default',
});

export const eventCardDetailsStyles = css.raw({ display: 'flex', flexDirection: 'column' });

export const eventCardActionsStyles = css.raw({ display: 'flex', alignItems: 'center', gap: 'default' });
